module.exports = __webpack_public_path__ + "static/media/zolePlayed_10_100.400f8e3b.png";